import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "preview-text relative"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  class: "relative pb-6 mt-2 flex-1"
};
const _hoisted_4 = {
  key: 0,
  class: "content"
};
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center items-center h-full"
};
import { ref, watch, nextTick } from 'vue';
import ScreenFull from '@components/ScreenFull.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'GenerateItem',
  props: {
    generating: {
      type: Boolean
    },
    text: {},
    title: {}
  },
  emits: ["toggleFull"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const screenFullRef = ref();
    const scrollBoxRef = ref();
    const toggleFull = () => {
      emits('toggleFull');
    };
    watch(() => props.text, val => {
      if (val) {
        nextTick(() => {
          scrollBoxRef.value.scrollTop = scrollBoxRef.value.scrollHeight;
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_full = _resolveComponent("i-home-full");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ScreenFull, {
        ref_key: "screenFullRef",
        ref: screenFullRef,
        class: "preview-box"
      }, {
        btn: _withCtx(() => [__props.text && __props.generating ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "footer-btn",
          onClick: toggleFull
        }, [_createVNode(_component_i_home_full, {
          class: "w-2 h-2"
        }), _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "ml-1"
        }, "查看/编辑", -1))])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "scrollBoxRef",
          ref: scrollBoxRef,
          class: "h-full overflow-y-auto flex flex-col scroll-box"
        }, [_createElementVNode("div", {
          class: "title line-clamp-2 min-h-7",
          title: __props.title
        }, _toDisplayString(__props.title), 9, _hoisted_2), _createElementVNode("div", _hoisted_3, [__props.text ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.text), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, "请选择要 查看/编辑 的知识库"))])], 512)]),
        _: 1
      }, 512)]);
    };
  }
});